<template>
  <div class="v2-file-upload">
    <label
      v-if="label"
      class="v2-file-upload__label"
    >{{ label }}</label>
    <label
      class="v2-file-upload__dropzone"
      :class="{ 'v2-file-upload__dropzone--disabled': disabled }"
    >
      <input
        ref="fileInput"
        type="file"
        :accept="accept"
        :disabled="disabled"
        class="v2-file-upload__input"
        @change="onFileChange"
      >
      <span class="v2-file-upload__text">
        {{ currentFileName || placeholder }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'V2FileUpload',
  props: {
    value: { type: [File, Object], default: null },
    accept: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Choose a file or drop it here...' },
    label: { type: String, default: '' },
  },
  computed: {
    currentFileName() {
      if (this.value instanceof File) return this.value.name
      return ''
    },
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0] || null
      this.$emit('input', file)
      e.target.value = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-file-upload {
  display: flex;
  flex-direction: column;
  gap: var(--v2-space-1);
}

.v2-file-upload__label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--v2-foreground);
}

.v2-file-upload__dropzone {
  display: flex;
  align-items: center;
  min-height: 38px;
  padding: var(--v2-space-2) var(--v2-space-3);
  // Dropzone — matches V2Input recipe (translucent fill + glass-stroke,
  // no `backdrop-filter`). Dashed border distinguishes it as a drop
  // target without leaving the glass language.
  border: 1px dashed var(--v2-glass-stroke);
  border-radius: var(--v2-radius-md);
  background: var(--v2-glass-surface-2);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: var(--v2-glass-stroke-strong);
  }

  &--disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: var(--v2-muted);

    &:hover {
      border-color: var(--v2-glass-stroke);
    }
  }
}

.v2-file-upload__input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

.v2-file-upload__text {
  font-family: var(--v2-font-sans);
  font-size: 0.875rem;
  color: var(--v2-muted-foreground);
}
</style>
